import AppWrapper from "@admin/AppWrapper";
import { GlobalLayout } from "@admin/layout";
import { Login, Register } from "@admin/pages";
import { Service503 } from "@admin/pages/errors";
import loadable from "@loadable/component";
import { Authenticated, CanAccess } from "@refinedev/core";
import { NavigateToResource } from "@refinedev/react-router-v6";
import type { RouteObject } from "react-router-dom";
import { createBrowserRouter, Navigate, Outlet } from "react-router-dom";
import { NoAccessError, NotFoundPage } from "ui/error";
import { v4 } from "uuid";

import { accountManagementRoutes } from "./accountManagement";
import { analyticsRoute } from "./analyticsRoute";
import { dashboardRoute } from "./dashboardRoute";
import { devicesConfigureRoute } from "./devicesConfigureRoute";
import { devicesRoute } from "./devicesRoute";
import { eazyUpdateDeleteRoute } from "./eazyUpdateDeleteRoute";
import { propertiesRoute } from "./propertiesRoute";
import { serviceRecordsRoute } from "./serviceRecordsRoute";
import { systemConfigureRoute } from "./systemConfigureRoute";
import { todoRoute } from "./todoRoute";
import { userListRoute } from "./userListRoute";

const ForgotPassword = loadable(() => import("ui/auth"), {
  resolveComponent: ({ ForgotPassword }) => ForgotPassword,
});

const app_routes = [
  {
    path: "/",
    element: (
      <AppWrapper>
        <Authenticated key={v4()}>
          <GlobalLayout>
            <CanAccess fallback={<NoAccessError />}>
              <Outlet />
            </CanAccess>
          </GlobalLayout>
        </Authenticated>
      </AppWrapper>
    ),
    children: [
      { index: true, element: <Navigate to="/analytics" /> },
      ...dashboardRoute,
      analyticsRoute,
      propertiesRoute,
      devicesRoute,
      devicesConfigureRoute,
      ...userListRoute,
      ...serviceRecordsRoute,
      systemConfigureRoute,
      ...accountManagementRoutes,
      eazyUpdateDeleteRoute,
      todoRoute,
      // ...lockerStationRoute,
      { path: "*", element: <NotFoundPage /> },
    ],
  },
  {
    element: (
      <AppWrapper>
        <Authenticated fallback={<Outlet />} key={v4()}>
          <NavigateToResource />
        </Authenticated>
      </AppWrapper>
    ),
    children: [
      { path: "/login", element: <Login /> },
      { path: "/register", element: <Register /> },
      { path: "/forgot-password", element: <ForgotPassword /> },
      { path: "/service-unavailable", element: <Service503 /> },
    ],
  },
] as RouteObject[];
export const router = createBrowserRouter(app_routes, { basename: "/admin" });
// export const router2 = createBrowserRouter(app_routes, { basename: "/desk" });
